import React, { useState } from 'react';
import Styles from './patchcenterStyle.module.scss';
import Card, { CardTitle } from '../../components/Card';

const ActionSelector = () => {
  const [selectedScript, setSelectedScript] = useState('');
  const [isExpanded, setIsExpanded] = useState('');

  const scripts = ['Restart Adobe Script', 'Stop Trend Micro AV', 'Stop Java Script'];

  const handleExpand = (section) => {
    setIsExpanded(isExpanded === section ? '' : section);
  };

  return (
    <div className={Styles.actionContainer}>
      <div className="flex flex-col w-72">
        {' '}
        {/* Increased width */}
        {/* <label className="text-gray-400 mb-1">Run Script</label> */}
        <select
          className={`${Styles.select_action_input} bg-[#2a2a2a] border border-gray-600 rounded-md px-3 py-2 focus:border-green-400 outline-none text-white w-full`}
        >
          <option value="" disabled selected hidden>
            Select Script
          </option>
          <option>Restart Adobe Script</option>
          <option>Stop Trend Micro AV</option>
          <option>Stop Java Script</option>
        </select>
      </div>
      <div className="flex flex-col w-72">
        {' '}
        {/* Increased width */}
        {/* <label className="text-gray-400 mb-1">Select Type</label> */}
        <select
          className={`${Styles.select_action_input} bg-[#2a2a2a] border border-gray-600 rounded-md px-3 py-2 focus:border-green-400 outline-none text-white w-full`}
        >
          <option>Install software</option>
        </select>
      </div>
      <div className="flex flex-col w-72">
        {' '}
        {/* Increased width */}
        {/* <label className="text-gray-400 mb-1">Select Type</label> */}
        <select
          className={`${Styles.select_action_input} bg-[#2a2a2a] border border-gray-600 rounded-md px-3 py-2 focus:border-green-400 outline-none text-white w-full`}
        >
          <option>Uninstall Software</option>
        </select>
      </div>
      <div className="flex flex-col w-72">
        {' '}
        {/* Increased width */}
        {/* <label className="text-gray-400 mb-1">Select Type</label> */}
        <select
          className={`${Styles.select_action_input} bg-[#2a2a2a] border border-gray-600 rounded-md px-3 py-2 focus:border-green-400 outline-none text-white w-full`}
        >
          <option>Reboot Device</option>
        </select>
      </div>
      <div className="flex flex-col w-72">
        {' '}
        {/* Increased width */}
        {/* <label className="text-gray-400 mb-1">Select Type</label> */}
        <select
          className={`${Styles.select_action_input} bg-[#2a2a2a] border border-gray-600 rounded-md px-3 py-2 focus:border-green-400 outline-none text-white w-full`}
        >
          <option>Change Registry Key</option>
        </select>
      </div>
      {/* <div onClick={() => handleExpand('runScript')} className={Styles.sectionHeader}>
        Run Script
      </div>
      {isExpanded === 'runScript' && (
        <div className={Styles.contentBox}>
          <select className={Styles.selectBox} value={selectedScript} onChange={(e) => setSelectedScript(e.target.value)}>
            <option value="">Select Script</option>
            {scripts.map((script, index) => (
              <option key={index} value={script}>
                {script}
              </option>
            ))}
          </select>
          <div className={Styles.buttonContainer}>
            <button className={Styles.clearButton}>Clear</button>
            <button className={Styles.applyButton}>Apply</button>
          </div>
        </div>
      )}

      {['Install Software', 'Uninstall Software', 'Reboot Device', 'Change Registry Key'].map((action) => (
        <div key={action} onClick={() => handleExpand(action)} className={Styles.sectionHeader}>
          {action}
        </div>
      ))} */}
    </div>
  );
};

const PlanActions = ({ closeModal2 }) => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const toggleSelection = (item: string) => {
    setSelectedItems((prev) => (prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]));
  };

  return (
    <div className={Styles.modalOverlay}>
      <div className={Styles.modalContent}>
        <Card>
          <CardTitle title="Create New Remediation Plan-Actions" />
          <div className="text-white flex ">
            <div className="w-[100%] p-6 rounded-xl shadow-lg">
              <div className="flex flex-col items-center w-full">
                <div className="flex justify-between w-full mb-2 relative">
                  {[1, 2, 3, 4, 5].map((step) => (
                    <div key={step} className="flex flex-col items-center w-full">
                      <div
                        className={`w-8 h-8 flex items-center justify-center rounded-full text-sm ${
                          step === 1 || step === 2 ? 'bg-green-500 text-black' : 'bg-gray-700 text-gray-400'
                        }`}
                      >
                        {step}
                      </div>
                    </div>
                  ))}
                </div>
                {/* Progress Bars */}
                <div className="flex justify-between w-full">
                  {[1, 2, 3, 4, 5].map((step) => (
                    <div key={step} className="w-full flex justify-center">
                      <div className={`h-2 rounded-lg ${step === 1 || step === 2 ? 'bg-green-500' : 'bg-gray-700'} w-4/5`}></div>
                    </div>
                  ))}
                </div>
              </div>

              <ActionSelector />
              <div className="mt-6 flex justify-end space-x-2.5">
                <button className="w-32 px-6 py-2 border border-gray-500 rounded-[30px] hover:bg-gray-700" onClick={closeModal2}>
                  Cancel
                </button>
                <button className="w-32 px-6 py-2 bg-red-600 rounded-[30px] shadow-md hover:bg-red-700">Next</button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PlanActions;
